import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import ReactDOM from 'react-dom';
import { consumeTheme } from '../../utils/theme';
import { PreventScrollPenetrateContainer } from '../../utils/preventScrollPenetrate';
import { decideKeepDom } from '../../utils/keepDom';
import { Button } from '../Button';
export var BOTTOM_MODAL_TRANSITION_DURATION = 200;
var BottomModal = (function (_super) {
    __extends(BottomModal, _super);
    function BottomModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a, _b, _c;
            var _d = _this.props, prefixCls = _d.prefixCls, className = _d.className, style = _d.style, visible = _d.visible, zIndex = _d.zIndex, testId = _d.testId, mask = _d.mask, preventScrollPenetrate = _d.preventScrollPenetrate, content = _d.content, closeClassName = _d.closeClassName, closeStyle = _d.closeStyle, onClose = _d.onClose;
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-hidden"] = !visible,
                _a));
            var maskClasses = classNames(prefixCls + "-mask", (_b = {},
                _b[prefixCls + "-mask-hidden"] = !visible,
                _b));
            var containerClasses = classNames(prefixCls + "-container", (_c = {},
                _c[prefixCls + "-container-no-mask"] = !mask,
                _c));
            if (!decideKeepDom.call(_this, BOTTOM_MODAL_TRANSITION_DURATION, visible)) {
                return null;
            }
            return ReactDOM.createPortal(h(PreventScrollPenetrateContainer, { disabled: typeof preventScrollPenetrate === 'boolean' ? !preventScrollPenetrate : !mask, className: containerClasses, style: { zIndex: zIndex } },
                mask && h("div", { className: maskClasses }),
                h(PreventScrollPenetrateContainer, { disabled: typeof preventScrollPenetrate === 'boolean' ? !preventScrollPenetrate : mask, className: classes, style: style, "data-testid": testId },
                    h("div", { className: classNames(prefixCls + "-close", closeClassName), style: closeStyle, onClick: onClose }),
                    _this.renderHeader(classNames),
                    content && h("div", { className: classNames(prefixCls + "-content") }, content),
                    _this.renderFooter(classNames))), document.body);
        };
        return _this;
    }
    BottomModal.prototype.renderHeader = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, title = _a.title, headerClassName = _a.headerClassName, headerStyle = _a.headerStyle, headerType = _a.headerType, icon = _a.icon, titleClassName = _a.titleClassName, titleStyle = _a.titleStyle, description = _a.description, descriptionClassName = _a.descriptionClassName, descriptionStyle = _a.descriptionStyle;
        if (!(title || icon || description)) {
            return null;
        }
        var titleElement = title && (h("div", { className: classNames(prefixCls + "-header-title", prefixCls + "-header-title-" + headerType, titleClassName), style: titleStyle }, title));
        var descElement = description && (h("div", { className: classNames(prefixCls + "-header-desc", prefixCls + "-header-desc-" + headerType, descriptionClassName), style: descriptionStyle }, description));
        var iconElement = icon && (h("div", { className: classNames(prefixCls + "-header-icon", prefixCls + "-header-icon-" + headerType), style: typeof icon === 'string' ? { backgroundImage: "url(\"" + icon + "\")" } : undefined }, typeof icon !== 'string' && icon));
        var headerCls = classNames(prefixCls + "-header", prefixCls + "-header-" + headerType, headerClassName);
        if (headerType === 'spread') {
            return (h("div", { className: headerCls, style: headerStyle },
                iconElement,
                titleElement,
                descElement));
        }
        if (headerType === 'compact') {
            return (h("div", { className: headerCls, style: headerStyle },
                iconElement,
                (titleElement || descElement) && h("div", { className: classNames(prefixCls + "-header-text-container") },
                    titleElement,
                    descElement)));
        }
        return null;
    };
    BottomModal.prototype.renderFooter = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, primaryAction = _a.primaryAction, onClickPrimaryAction = _a.onClickPrimaryAction, secondaryAction = _a.secondaryAction, onClickSecondaryAction = _a.onClickSecondaryAction, footerClassName = _a.footerClassName, footerStyle = _a.footerStyle, primaryActionButtonType = _a.primaryActionButtonType, primaryActionClassName = _a.primaryActionClassName, primaryActionStyle = _a.primaryActionStyle, secondaryActionClassName = _a.secondaryActionClassName, secondaryActionStyle = _a.secondaryActionStyle;
        return (primaryAction && h("div", { className: classNames(prefixCls + "-footer", footerClassName), style: footerStyle },
            h("div", { className: classNames(prefixCls + "-footer-primary-action", primaryActionClassName), style: primaryActionStyle, onClick: onClickPrimaryAction }, typeof primaryAction === 'string'
                ? h(Button, { type: primaryActionButtonType, size: "large" }, primaryAction)
                : primaryAction),
            secondaryAction &&
                h("div", { className: classNames(prefixCls + "-footer-secondary-action", secondaryActionClassName), style: secondaryActionStyle, onClick: onClickSecondaryAction }, secondaryAction)));
    };
    BottomModal.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return BottomModal;
}(React.Component));
export default BottomModal;
BottomModal.defaultProps = {
    prefixCls: 'dui-m-bottommodal',
    mask: true,
    headerType: 'spread',
    primaryActionButtonType: 'primary',
};
